(function () {
  var scrollY = 0;

  function lockBody() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var sbw = window.innerWidth - document.documentElement.clientWidth; // スクロールバー幅
    document.body.style.top = (-scrollY) + 'px';
    document.body.classList.add('scroll-lock');
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }

  function unlockBody() {
    document.body.classList.remove('scroll-lock');
    document.body.style.top = '';
    document.body.style.paddingRight = '';
    window.scrollTo(0, scrollY);
  }

  $('.gallery').colorbox({
    rel: "group",
    maxWidth: "90%",
    maxHeight: "90%",
    opacity: 0.7,
    fixed: true,
    reposition: true,
    photo: true,
    scalePhotos: true,
    scrolling: false,
    onOpen: lockBody,
    onClosed: unlockBody,
    onComplete: function () {
      $.colorbox.position(); // 読み込み後に位置を再計算
    }
  });

  $(window).on('resize orientationchange', function () {
    if ($('#colorbox').is(':visible')) {
      $.colorbox.position();
    }
  });
})();
